module.exports = function() {
  return new Worker(__webpack_public_path__ + "2c243be91f85fd8475a8.worker.js");
};